// eslint-disable-next-line
// @ts-nocheck
import { toUpper } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useParams, useNavigate, useLocation } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Collapse,
  TableHead,
  Modal,
  Select,
  Tooltip,
  MenuItem,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// components
import Page from '../components/Page';
import ClearIcon from '@mui/icons-material/Clear';

import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { BookingListHead, BookingListToolbar } from '../sections/@dashboard/bookings';
// mock
import { getbookingSpaces, setBookings, getBookingTotalRecords } from '../store/state/bookingSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  useGetAllBookingDetailBySearchCriteriaMutation,
  useUpdateBookingDetailMutation,
} from '../store/api/bookingsApi';
import {
  useLineUpLabourWithBookingMutation,
  useUpdateBookingStatusByLabourMutation,
} from '../store/api/labourBookingApi';
import { useGetCheckInDetailsMutation } from '../store/api/subBookingApi';
import { formatTime, getUniqueKey, roundNumber, timeInMiliseconds } from '../sections/@dashboard/parkingspaces/utility';
import Loading from '../components/Loading';
import { styled } from '@mui/material/styles';
import '../components/Style.css';
import { useUpdateActualTimeMutation } from '../store/api/bookingsApi';
import { fDateTimeSuffix } from '../utils/formatTime';
import { useCheckStatusMutation, useStartPaymentMutation } from '../store/api/posApi';
import toast from 'react-hot-toast';
import { useGetAllDeviceDataMutation } from '../store/api/posDeviceApi';
import { Formik } from 'formik';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SyncIcon from '@mui/icons-material/Sync';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import AppsTwoToneIcon from '@mui/icons-material/AppsTwoTone';
//import {
// getLabourDetails,
//  getLabourTotalRecords,
// setLabourDetails,
//} from '../store/state/labourSlice';
import {
  useGetAllLabourDetailMutation,
  useDeleteLabourDetailByIdMutation, useFindAvailableLabourDetailMutation,
} from '../store/api/labourApi';

const loginDetails = JSON.parse(localStorage.getItem('login') || '{}');
const userType = loginDetails.userType;
const labourDetails = JSON.parse(localStorage.getItem('labourDetail') || '{}');
const labourId = labourDetails.id;
console.log('Labour Id', labourId);

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginRight: '20px',
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

const MarginBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '10px',
  },
  [theme.breakpoints.up('md')]: {},
}));

const flag = ['CURRENT_BOOKING', 'PAST_BOOKING', 'CANCEL_BOOKING', 'IN_TRANSIT'];
//const labourFlag = ['ACCEPTED', 'REQUESTED', 'REJECTED'];

export default function Bookings() {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingSpacesData = useAppSelector(getbookingSpaces);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const [bookingSpaces, setbookingSpaces] = useState([]);
  const bookingTotalRecords = useAppSelector(getBookingTotalRecords);
  const [getAllBookingDetailBySearchCriteria, getAllBookingResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [getAllCancellationCount, cancelCountResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [getCheckInDetails, getCheckInDetailsResponse] = useGetCheckInDetailsMutation();
  const [lineUpLabourWithBooking, lineUpLabourWithBookingResponse] = useLineUpLabourWithBookingMutation();
  const [updateBookingStatusByLabour, updateBookingStatusByLabourResponse] = useUpdateBookingStatusByLabourMutation();
  const [cancelCount, setCancelCount] = useState(0);
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [value, setValue] = useState(0);
  console.log(value, "value");
  const [getFlag, setFlag] = useState<string>(
    location.state?.getflag ?? flag[0]
  );
  const [labourFlag, setLabourFlag] = useState<string>(
    location.state?.labourFlag ?? (userType === 'UTLB' ? 'REQUEST_LABOUR' : null)
  );
  console.log("labourFlag", location.state?.labourFlag);
  const [bookingFlag, setBookingFlag] = useState<string>(null);
  console.log(getFlag, 'getFlag');
  const [data, setData] = useState<string | null>(null);
  const [responseData, setResponseData] = useState<any>();
  console.log('responseData', responseData);
  const [updateActualTime, updateActualTimeResponse] = useUpdateActualTimeMutation();
  const authData = JSON.parse(localStorage.getItem('login') || '{}');
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [valueID, setValueID] = useState();
  const [subBooking, setSubBooking] = useState([]);
  const filteredUsers = bookingSpaces;
  //console.log("filteredUsers booking",filteredUsers);
  const isUserNotFound = filteredUsers.length === 0;
  const checkInStatusStyle = { color: '#f57f10' };
  const completedStatusStyle = { color: '#217208' };
  const checkoutStatusStyle = { color: 'red' };
  const [startPayment, startPaymentResponse] = useStartPaymentMutation();
  const [checkStatus, checkStatusResponse] = useCheckStatusMutation();
  const [updateBookingDetail, updateBookingDetailResponse] = useUpdateBookingDetailMutation();
  const [rowData, setRowData] = useState();
  console.log(rowData, "rowData")
  const [messageCode, setMessageCode] = useState();
  const [id, setId] = useState() as any;
  const [traxnId, setTraxnId] = useState() as any;
  const [getAllDeviceData, getAllDeviceDataResponse] = useGetAllDeviceDataMutation();
  //const [getAllLabourDetail, labourResponse] = useGetAllLabourDetailMutation();
  const [getAllAvailableLabourDetail, labourResponse] = useFindAvailableLabourDetailMutation();
  //const labourData = useAppSelector(getLabourDetails);
  //const [labourers, setLabourers] =useState([]);
  const [labourers, setLabourDetails] = useState([]);
  const [posDeviceData, setPosDeviceData] = useState([]) as any;
  const [openAddDriverModal, setOpenAddDriverModal] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState() as any;
  console.log(posDeviceData, "posDeviceData");
  const [initialValues, setInitialValues] = useState({
    posDevice: '',
    addDriver: '',
  });
  const msg = "";

  const TABLE_HEAD = [
    { id: 'bookingCode', label: 'Booking Code', alignRight: false },
    { id: 'name', label: 'Customer Name', alignRight: false },
    { id: 'vendorName', label: 'Vendor Name', alignRight: false },
    // { id: 'parkingSpaceName', label: 'Parking Space Name', alignRight: false },
    { id: 'amount', label: 'Booking Amount', alignRight: false },
    // { id: 'parkingCategory', label: 'Parking Category', alignRight: false },
    { id: 'bookingDate', label: 'Booking Date', alignRight: false },
    { id: 'pickupDate', label: 'Pickup Date', alignRight: false },
    { id: 'dropoffDate', label: 'Dropoff Date', alignRight: false },
    { id: 'pickupAddress', label: 'Pickup Address', alignRight: false },
    { id: 'dropoffAddress', label: 'Dropoff Address', alignRight: false },
    // { id: 'timer', label: 'Duration', alignRight: false },
    // pos code start
    // { id: 'action', label: 'Action', alignRight: false },
    // pos code end
    { id: 'status', label: 'Booking Status', alignRight: false },
    ...(userType !== 'UTLB' ? [{ id: 'driverName', label: 'Driver Name', alignRight: false },]
      : []),
    ...((userType === 'UTLB') &&
      labourFlag !== 'IN_TRANSIT' &&
      getFlag == 'CURRENT_BOOKING' 
      ? [{ id: 'actions', label: 'Actions', alignRight: false }]
      : []),

    ...((userType === 'UTSP') && ((labourFlag === 'LABOUR_REJECTED') || (labourFlag === null))
      ? [{ id: 'addDriver', label: 'Action', alignRight: false }]
      : []),
  ];

  const TABLE_HEAD_CANCELBOOKING = [
    { id: 'bookingCode', label: 'Booking Code', alignRight: false },
    { id: 'name', label: 'Customer Name', alignRight: false },
    { id: 'vendorName', label: 'Vendor Name', alignRight: false },
    // { id: 'parkingSpaceName', label: 'Parking Space Name', alignRight: false },
    { id: 'amount', label: 'Booking Amount', alignRight: false },
    { id: 'bookingDate', label: 'Booking Date', alignRight: false },
    { id: 'status', label: 'Booking Status', alignRight: false },
    { id: 'cancelReasons', label: 'Cancellation Reason', alignRight: false },
  ];

  const validate = (values: any) => {
    //console.log(values)
    const errors: any = {};

    if (!values.posDevice) errors['posDevice'] = 'This field is required';

    if (!values.addDriver) errors['addDriver'] = 'This field is required';
    return errors;
  };

  const styleActiveModel = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '30px',
  };

  const handleOpen = (id: any) => {
    setOpen(true);
    getCheckInDetails({
      id: id,
      token: token.token,
    });
  };
  const handleClose = () => setOpen(false);


  const handleOpenModal = (id: any) => {
    console.log(id, id);
    setOpenModal(true);
    getAllDeviceData({
      token: token.token,
      payload: {
        offset: 100,
        page: 0,
        parkingLocationId: id,
        status: true,
      },
    });

  };
  const handleCloseModal = () => setOpenModal(false);


  useEffect(() => {
    if (getAllDeviceDataResponse.isSuccess) {
      setPosDeviceData(getAllDeviceDataResponse.data.data);
    }
    if (getAllDeviceDataResponse.isError) {
      let errorData: any = getAllDeviceDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllDeviceDataResponse.isSuccess, getAllDeviceDataResponse.isError]);

  const handleSubTable = async (value) => {
    setOpens(!opens);
    setValueID(value);
  };

  useEffect(() => {
    if (data && authData) {
      setFlag(data.substring(data.lastIndexOf('|') + 1));
      updateActualAsync(data, authData.token);
    }
  }, [data]);

  const updateActualAsync = async (data: string, token: string) => {
    await updateActualTime({
      token: token,
      payload: {
        bookingQr: data,
        isGuest: false,
        isVirtual: false,
        flag: data.substring(data.lastIndexOf('|') + 1),
      },
    });
  };

  useEffect(() => {
    if (getCheckInDetailsResponse.isSuccess) {
      setSubBooking(getCheckInDetailsResponse.data);
    }
  }, [getCheckInDetailsResponse.isSuccess]);

  useEffect(() => {
    if (updateActualTimeResponse.isSuccess) {
      setResponseData(updateActualTimeResponse.data);
    }
  }, [updateActualTimeResponse.isSuccess]);

  useEffect(() => {
    if (bookingSpacesData) {
      setbookingSpaces(bookingSpacesData);
    }
  }, [bookingSpacesData]);

  {/**useEffect(() => {
    if(userType === 'UTLB'){
      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
          name: orderBy,
          labourId: labourId,
          labourStatus: labourFlag,
          flag: flag[0],
        },
      });
    } else {
    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        name: orderBy,
        serviceProviderId: token.serviceProviderId,
        flag: flag[0],
      },
    });
  }
    setFilterName('');
    setValue(0);
  }, []); */}

  useEffect(() => {
    getAllCancellationCount({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        name: orderBy,
        serviceProviderId: token.serviceProviderId,
        flag: 'CANCEL_REVIEW_BOOKING',
      },
    });
  }, []);

  useEffect(() => {
    if (getAllBookingResponse.isSuccess) {
      dispatch(setBookings(getAllBookingResponse.data));
    }
    if (getAllBookingResponse.isError) {
      const errorData: any = getAllBookingResponse.error;
      const msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllBookingResponse.isSuccess, getAllBookingResponse.isError]);

  useEffect(() => {
    if (cancelCountResponse.isSuccess) {
      setCancelCount(cancelCountResponse.data?.totalRecords);
    }
    if (cancelCountResponse.isError) {
      const errorData: any = cancelCountResponse.error;
      const msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [cancelCountResponse.isSuccess, cancelCountResponse.isError]);

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handleChange = (event, newValue) => {
    setPage(0);
    setRowsPerPage(5);
    setValue(newValue);
    setFlag(flag[newValue]);

    if (userType === "UTLB") {
      const payload = {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        name: orderBy,
        labourId: labourId,
        flag: flag[newValue],
      };

      if (flag[newValue] !== "PAST_BOOKING" && flag[newValue] !== "CANCEL_BOOKING") {
        payload.labourStatus = labourFlag;
      }

      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: payload,
      });
    } else {
      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          orderBy: order,
          page: page,
          columnName: orderBy,
          flag: flag[newValue],
          serviceProviderId: token.serviceProviderId,
        },
      });
    }
  };

  const handleStatusChange = (status: string) => {
    setPage(0);
    setRowsPerPage(5);
    setLabourFlag(status);
    console.log("Labour Flag Status:", status);
  };

  useEffect(() => {
    if (labourFlag !== null) {
      console.log("Updated Labour Flag:", labourFlag);

      const payload = {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        columnName: orderBy,
        flag: labourFlag,
      };

      if (userType === 'UTLB') {
        payload.name = orderBy;
        payload.labourId = labourId;
      } else {
        payload.serviceProviderId = token.serviceProviderId;
      }

      if (labourFlag !== 'IN_TRANSIT') {
        payload.labourStatus = labourFlag;
      }

      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload,
      });
    } else {
      const payload = {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        columnName: orderBy,
        flag: 'CURRENT_BOOKING',
      };

      if (userType === 'UTLB') {
        payload.name = orderBy;
        payload.labourId = labourId;
      } else {
        payload.serviceProviderId = token.serviceProviderId;
      }

      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload,
      });
    }
  }, [labourFlag]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';

    setOrder(newOrder);
    setOrderBy(property);

    let updatedFlag = labourFlag === 'IN_TRANSIT'
      ? 'IN_TRANSIT'
      : labourFlag === null
        ? 'CURRENT_BOOKING'
        : getFlag === 'PAST_BOOKING'
          ? 'PAST_BOOKING'
          : getFlag === 'CANCEL_BOOKING'
            ? 'CANCEL_BOOKING'
            : labourFlag;

    let updatedLabourStatus = (updatedFlag !== 'PAST_BOOKING' && updatedFlag !== 'CANCEL_BOOKING' && updatedFlag !== 'IN_TRANSIT') ? labourFlag : null;

    if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
      updatedLabourStatus = null;
    }

    const payload = {
      offset: rowsPerPage,
      page: page,
      orderBy: newOrder,
      name: property,
      flag: updatedFlag,
      labourStatus: updatedLabourStatus,
    };

    if (userType === 'UTLB') {
      payload.labourId = labourId;
    } else {
      payload.serviceProviderId = token.serviceProviderId;
    }

    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: payload,
    });
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = bookingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  /** const handleChangePage = async (event, newPage) => {
     setPage(newPage);
   
     let updatedLabourStatus = labourFlag;
     let updatedFlag = labourFlag === null ? 'CURRENT_BOOKING' : labourFlag === 'IN_TRANSIT' ? 'IN_TRANSIT' : labourFlag;
   
     if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
       updatedLabourStatus = null;
     }
   
     const payload = {
       offset: rowsPerPage,
       page: newPage,
       orderBy: order,
       name: orderBy,
       flag: updatedFlag,
       labourStatus: updatedLabourStatus,
     };
   
     if (userType === 'UTLB') {
       payload.labourId = labourId;
     } else {
       payload.serviceProviderId = token.serviceProviderId;
     }
   
     await getAllBookingDetailBySearchCriteria({
       token: token.token,
       payload: payload,
     });
   }; */

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);

    let updatedFlag = labourFlag === 'IN_TRANSIT'
      ? 'IN_TRANSIT'
      : labourFlag === null
        ? 'CURRENT_BOOKING'
        : getFlag === 'PAST_BOOKING'
          ? 'PAST_BOOKING'
          : getFlag === 'CANCEL_BOOKING'
            ? 'CANCEL_BOOKING'
            : labourFlag;

    let updatedLabourStatus = (updatedFlag !== 'PAST_BOOKING' && updatedFlag !== 'CANCEL_BOOKING' && updatedFlag !== 'IN_TRANSIT') ? labourFlag : null;

    if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
      updatedLabourStatus = null;
    }

    const payload = {
      offset: rowsPerPage,
      page: newPage,
      orderBy: order,
      name: orderBy,
      flag: updatedFlag,
      labourStatus: updatedLabourStatus,
    };

    if (userType === 'UTLB') {
      payload.labourId = labourId;
    } else {
      payload.serviceProviderId = token.serviceProviderId;
    }

    await getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: payload,
    });
  };

  /** const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  
    let updatedLabourStatus = labourFlag;
    let updatedFlag = labourFlag === null ? 'CURRENT_BOOKING' : labourFlag === 'IN_TRANSIT' ? 'IN_TRANSIT' : labourFlag;
  
    if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
      updatedLabourStatus = null;
    }
  
    const payload = {
      offset: newRowsPerPage,
      page: 0,
      orderBy: order,
      name: orderBy,
      flag: updatedFlag,
      labourStatus: updatedLabourStatus,
    };
  
    if (userType === 'UTLB') {
      payload.labourId = labourId;
    } else {
      payload.serviceProviderId = token.serviceProviderId;
    }
  
    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: payload,
    });
  };

 const handleFilterByName = (event) => {
    const filterValue = event.target.value;
    setFilterName(filterValue);
  
    let updatedLabourStatus = labourFlag;
    let updatedFlag = labourFlag === null ? 'CURRENT_BOOKING' : labourFlag === 'IN_TRANSIT' ? 'IN_TRANSIT' : labourFlag;
  
    if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
      updatedLabourStatus = null;
    }
  
    const payload = {
      offset: rowsPerPage,
      page: page,
      orderBy: order,
      name: orderBy,
      flag: updatedFlag,
      labourStatus: updatedLabourStatus,
      customerName: filterValue, 
    };
  
    if (userType === 'UTLB') {
      payload.labourId = labourId;
    } else {
      payload.serviceProviderId = token.serviceProviderId;
    }
  
    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: payload,
    });
  }; */
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);

    let updatedFlag = labourFlag === 'IN_TRANSIT'
      ? 'IN_TRANSIT'
      : labourFlag === null
        ? 'CURRENT_BOOKING'
        : getFlag === 'PAST_BOOKING'
          ? 'PAST_BOOKING'
          : getFlag === 'CANCEL_BOOKING'
            ? 'CANCEL_BOOKING'
            : labourFlag;

    let updatedLabourStatus = (updatedFlag !== 'PAST_BOOKING' && updatedFlag !== 'CANCEL_BOOKING' && updatedFlag !== 'IN_TRANSIT') ? labourFlag : null;

    if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
      updatedLabourStatus = null;
    }

    const payload = {
      offset: newRowsPerPage,
      page: 0,
      orderBy: order,
      name: orderBy,
      flag: updatedFlag,
      labourStatus: updatedLabourStatus,
    };

    if (userType === 'UTLB') {
      payload.labourId = labourId;
    } else {
      payload.serviceProviderId = token.serviceProviderId;
    }

    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: payload,
    });
  };

  const handleFilterByName = (event) => {
    const filterValue = event.target.value;
    setFilterName(filterValue);

    let updatedFlag = labourFlag === 'IN_TRANSIT'
      ? 'IN_TRANSIT'
      : labourFlag === null
        ? 'CURRENT_BOOKING'
        : getFlag === 'PAST_BOOKING'
          ? 'PAST_BOOKING'
          : getFlag === 'CANCEL_BOOKING'
            ? 'CANCEL_BOOKING'
            : labourFlag;

    let updatedLabourStatus = (updatedFlag !== 'PAST_BOOKING' && updatedFlag !== 'CANCEL_BOOKING' && updatedFlag !== 'IN_TRANSIT') ? labourFlag : null;

    const payload = {
      offset: rowsPerPage,
      page: page,
      orderBy: order,
      name: orderBy,
      flag: updatedFlag,
      customerName: filterValue,
      labourStatus: updatedLabourStatus,
    };


    if (userType === 'UTLB') {
      payload.labourId = labourId;
    } else {
      payload.serviceProviderId = token.serviceProviderId;
    }

    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: payload,
    });
  };

  const capitalize = (value: any) => {
    if (value) {
      return value
        .match(/\b(\w)/g)
        .join('')
        .toUpperCase();
    }
  };

  // pos code start
  const handleStartPayment = (values) => {
    handleCloseModal();
    startPayment({
      token: token.token,
      payload: {
        amount: rowData.totalAmount,
        appKey: '252488f7-42d5-4830-bffc-a75e54214807',
        customerEmail: rowData.customerDetailResponseDTO.email,
        customerMobileNumber: rowData.customerDetailResponseDTO.phoneNo,
        customerName: rowData.customerDetailResponseDTO.name,
        externalRefNumber: rowData.bookingCode,
        mode: 'ALL',
        pushTo: { deviceId: `${values.posDevice}|ezetap_android` },
        username: '3939000201',
      },
    });
  };

  function handleCheckStatus() {
    checkStatus({
      token: authData.token,
      requestId: startPaymentResponse?.data?.p2pRequestId,
    });
  }

  useEffect(() => {
    if (startPaymentResponse?.data?.success === true) {
      const intervalID = setInterval(handleCheckStatus, 5000);
      setId(intervalID);
    }
    if (startPaymentResponse?.data?.success === false) {
      const errorData: any = startPaymentResponse?.data?.errorMessage;
      toast.error('Something went wrong. ' + errorData);
    }
    // return () => clearInterval(id);
  }, [startPaymentResponse?.data]);

  useEffect(() => {
    if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_TXN_DONE'
    ) {
      setTraxnId(checkStatusResponse?.data?.txnId);
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success('Transaction successfully done on POS Device.');
      }
      handlePayment(rowData);
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.errorMessage ==
      'You have already made a similar payment for the same Ref# null and amount {1}. Please check the status of the payment(s) made before you proceed.' &&
      checkStatusResponse?.data?.status === 'FAILED' &&
      checkStatusResponse?.data?.success === false
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success(
          'You have already made a similar payment for the same request and amount. Please check the status of the payment(s) made before you proceed.'
        );
      }
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_STATUS_QUEUED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) toast.success('Request queued please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_RECEIVED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode)
        toast.success('Notification has been received on POS Device. Please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_CANCELED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.error('Transaction has been canceled on POS Device.');
      }
      clearInterval(id);
      setId(0);
    } else if (checkStatusResponse?.data?.success === false) {
      setMessageCode(checkStatusResponse?.data?.errorData);
      const errorData: any = checkStatusResponse?.data?.errorMessage;
      if (messageCode !== checkStatusResponse?.data?.errorData) {
        toast.error('Something went wrong ' + errorData);
      }
      clearInterval(id);
      setId(0);
    }
    // return () => clearInterval(id);
  }, [checkStatusResponse?.data, messageCode]);

  const handlePayment = (rowData: any) => {
    updateBookingDetail({
      token: authData.token,
      payload: {
        bookingAmount: rowData.bookingAmount,
        bookingCode: rowData.bookingCode,
        bookingDate: rowData.bookingDate,
        bookingStatus: rowData.bookingStatus,
        cardAmount: rowData.cardAmount,
        cartId: rowData.cartId,
        checkinTime: rowData.checkinTime,
        checkoutTime: rowData.checkoutTime,
        convenienceFee: rowData.convenienceFee,
        countyTax: rowData.countyTax,
        customerId: rowData.customerId,
        // customerVehicleDetailResDTO: {
        //   customerId: rowData.customerVehicleDetailResDTO.customerId,
        //   id: rowData.customerVehicleDetailResDTO.id,
        //   isCommercial: rowData.customerVehicleDetailResDTO.isCommercial,
        //   isPrimary: rowData.customerVehicleDetailResDTO.isPrimary,
        //   makerName: rowData.customerVehicleDetailResDTO.makerName,
        //   modelNumber: rowData.customerVehicleDetailResDTO.modelNumber,
        //   status: rowData.customerVehicleDetailResDTO.status,
        //   vehicleCategory: rowData.customerVehicleDetailResDTO.vehicleCategory,
        //   vehicleNumber: rowData.customerVehicleDetailResDTO.vehicleNumber,
        // },
        disputeResolutionDate: rowData.disputeResolutionDate,
        email: rowData.customerDetailResponseDTO.email,
        // extraAmount: rowData.extraAmount,
        // extraAmtTransId: rowData.extraAmtTransId,
        fixedFee: rowData.fixedFee,
        id: rowData.id,
        // invoiceDate: rowData.invoiceDate,
        invoiceType: 'POS',
        isDisputed: rowData.isDisputed,
        isGuest: rowData.isGuest,
        isParked: rowData.isParked,
        isVendorPaid: rowData.isVendorPaid,
        // offerDetailId: rowData.offerDetailId,
        paidBy: rowData.paidBy,
        parkingCategoryId: rowData.parkingCategoryId,
        parkingLocationId: rowData.parkingLocationId,
        parkingSlotId: rowData.parkingSlotId,
        // paymentMethodId: rowData.paymentMethodId,
        paymentStatus: 'Completed',
        phoneNo: rowData.customerDetailResponseDTO.phoneNo,
        // qrImage: rowData.qrImage,
        rewardGained: rowData.rewardGained,
        rewardUsed: rowData.rewardUsed,
        salesTax: rowData.salesTax,
        serviceProviderId: rowData.serviceProviderId,
        stateTax: rowData.stateTax,
        status: rowData.status,
        subBookingId: rowData.subBookingDetailList[0].id,
        taxAmount: rowData.taxAmount,
        totalAmount: rowData.totalAmount,
        transactionRefId: traxnId,
        uniqueBookingId: rowData.uniqueBookingId,
        userTimezone: rowData.userTimezone,
        vehicleNumber: rowData.vehicleNumber,
      },
    });
  };

  useEffect(() => {
    if (updateBookingDetailResponse.isSuccess) {
      setTimeout(() => {
        toast.success('Payment completed!');
      }, 3000);
      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          orderBy: order,
          page: page,
          columnName: orderBy,
          flag: getFlag,
          serviceProviderId: token.serviceProviderId,
        },
      });
    } else if (updateBookingDetailResponse.isError) {
      const errorData: any = updateBookingDetailResponse.error;
      const msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [updateBookingDetailResponse.isSuccess, updateBookingDetailResponse.isError]);
  // pos code end

  const handleAddDriver = (id) => {
    setOpenAddDriverModal(true);
    setSelectedBookingId(id);
    console.log("Booking id:", id);

    setFilterName('');

    getAllAvailableLabourDetail({
      token: token.token,
      bookingId: id,
    });
  };


  useEffect(() => {
    if (updateBookingStatusByLabourResponse.isSuccess) {
      let updatedLabourStatus = labourFlag;
      let updatedFlag = labourFlag === null ? 'CURRENT_BOOKING' : labourFlag === 'IN_TRANSIT' ? 'IN_TRANSIT' : labourFlag;

      if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
        updatedLabourStatus = null;
      }

      const payload = {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        name: orderBy,
        flag: updatedFlag,
        labourStatus: updatedLabourStatus,
      };

      if (userType === 'UTLB') {
        payload.labourId = labourId;
      } else {
        payload.serviceProviderId = token.serviceProviderId;
      }

      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: payload,
      });

      setFilterName('');
      setValue(0);
    }

    if (updateBookingStatusByLabourResponse.isError) {
      let errorData: any = updateBookingStatusByLabourResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + (msg || ''));
    }
  }, [updateBookingStatusByLabourResponse.isSuccess]);


  const handleCloseAddDriverModal = () => {
    setOpenAddDriverModal(false);
  };

  useEffect(() => {
    if (labourResponse.isSuccess) {
      setLabourDetails(labourResponse.data);
      console.log('Labour Detail', labourResponse.data);
      console.log('setLabourDetail', setLabourDetails);
    }

    if (labourResponse.isError) {
      let errorData: any = labourResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [labourResponse.isSuccess, labourResponse.isSuccess]);

  //useEffect(() => {
  //  if (labourData) {
  //   setLabourers(labourData);
  //console.log('Labour Data Set',labourData);
  //  }
  // }, [labourData]);

  const handleSubmitForm = (values, { resetForm }) => {
    console.log("Booking id in submit:", selectedBookingId);
    console.log("Labour id in submit:", values.addDriver);

    lineUpLabourWithBooking({
      labourId: values.addDriver,
      bookingId: selectedBookingId,
      token: token.token,
      status: 'REQUEST_LABOUR',
    });
    resetForm();
    handleCloseAddDriverModal();
  };

  useEffect(() => {
    if (lineUpLabourWithBookingResponse.isSuccess) {
      let updatedLabourStatus = labourFlag;
      let updatedFlag = labourFlag === null ? 'CURRENT_BOOKING' : labourFlag === 'IN_TRANSIT' ? 'IN_TRANSIT' : labourFlag;

      if (labourFlag === null || labourFlag === 'IN_TRANSIT') {
        updatedLabourStatus = null;
      }

      const payload = {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
        name: orderBy,
        flag: updatedFlag,
        labourStatus: updatedLabourStatus,
      };

      if (userType === 'UTLB') {
        payload.labourId = labourId;
      } else {
        payload.serviceProviderId = token.serviceProviderId;
      }

      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: payload,
      });

      setFilterName('');
      setValue(0);
    }
    if (labourResponse.isError) {
      console.log('Something went wrong: ' + (msg || 'No additional details'));
    }
  }, [lineUpLabourWithBookingResponse.isSuccess, lineUpLabourWithBookingResponse.isError]);

  const inTransitIndex = flag.indexOf('IN_TRANSIT');

  return (
    <Page title="Booking Overview">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Booking Overview
          </Typography>

          <ResponsiveBox
            style={{
              dispaly: 'flex',
            }}
          >
            <MarginBox>
              {userType !== 'UTLB' && (
                <>
                  {/** <Button
                style={{
                  marginRight: '10px',
                  color: 'white',
                  backgroundColor: '#E23744',
                }}
                size="large"
                variant="contained"
                onClick={() => {
                  navigate('/dashboard/create-new-booking');
                }}
              >
                Create New Booking
              </Button>

              <Button
                style={{
                  marginRight: '10px',
                  color: 'white',
                  backgroundColor: '#E23744',
                }}
                size="large"
                variant="contained"
                onClick={() => {
                  navigate('/dashboard/scan');
                }}
              >
                Scan By QR
              </Button>  */}

                  <Button
                    style={{
                      marginRight: '10px',
                      color: 'white',
                      backgroundColor: '#E23744',
                    }}
                    size="large"
                    variant="contained"
                    onClick={() => {
                      navigate('/dashboard/cancellations');
                    }}
                  >
                    {`All Cancellations (${cancelCount})`}
                  </Button>
                </>
              )}
            </MarginBox>
          </ResponsiveBox>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={5}>
          <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
            <LinkTab className="tab" label="Current Bookings" />
            <LinkTab className="tab" label="Past Bookings" />
            <LinkTab className="tab" label="Cancelled Bookings" />
          </Tabs>
        </Stack>
        <Card>


          <Stack direction="row" alignItems="center" justifyContent="space-between">
            {(getFlag === 'CURRENT_BOOKING' || getFlag === 'IN_TRANSIT') && (
              <Stack direction="row" spacing={3} ml={2}>
                {userType !== 'UTLB' && (
                  <Tooltip title="All">
                    <IconButton
                      onClick={() => handleStatusChange(null)}
                      sx={{
                        color: labourFlag === null ? 'primary.main' : 'grey.700',
                        backgroundColor: labourFlag === null ? 'grey.300' : 'grey.200',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        '&:hover': {
                          backgroundColor: 'grey.300',
                          color: 'primary.main',
                        },
                      }}
                    >
                      <AppsTwoToneIcon fontSize="large" />
                    </IconButton>
                  </Tooltip>)}
                <Tooltip title="All Requests">
                  <IconButton
                    onClick={() => handleStatusChange('REQUEST_LABOUR')}
                    sx={{
                      color: labourFlag === 'REQUEST_LABOUR' ? 'primary.main' : 'grey.700',
                      backgroundColor: labourFlag === 'REQUEST_LABOUR' ? 'grey.300' : 'grey.200',
                      borderRadius: '50%',
                      width: '48px',
                      height: '48px',
                      '&:hover': {
                        backgroundColor: 'grey.300',
                        color: 'primary.main',
                      },
                    }}
                  >
                    <PendingActionsIcon fontSize="large" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Accepted Bookings">
                  <IconButton
                    onClick={() => handleStatusChange('LABOUR_ACCEPTED')}
                    sx={{
                      color: labourFlag === 'LABOUR_ACCEPTED' ? 'primary.main' : 'grey.700',
                      backgroundColor: labourFlag === 'LABOUR_ACCEPTED' ? 'grey.300' : 'grey.200',
                      borderRadius: '50%',
                      width: '48px',
                      height: '48px',
                      '&:hover': {
                        backgroundColor: 'grey.300',
                        color: 'primary.main',
                      },
                    }}
                  >
                    <TaskAltIcon fontSize="large" />
                  </IconButton>
                </Tooltip>
                {userType !== 'UTLB' && (
                  <Tooltip title="Driver Rejected">
                    <IconButton
                      onClick={() => handleStatusChange('LABOUR_REJECTED')}
                      sx={{
                        color: labourFlag === 'LABOUR_REJECTED' ? 'primary.main' : 'grey.700',
                        backgroundColor: labourFlag === 'LABOUR_REJECTED' ? 'grey.300' : 'grey.200',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        '&:hover': {
                          backgroundColor: 'grey.300',
                          color: 'primary.main',
                        },
                      }}
                    >
                      <CancelOutlinedIcon fontSize="large" />
                    </IconButton>
                  </Tooltip>)}

                <Tooltip title="In Transit">
                  <IconButton
                    onClick={() => handleStatusChange('IN_TRANSIT')}
                    sx={{
                      color: labourFlag === 'IN_TRANSIT' ? 'primary.main' : 'grey.700',
                      backgroundColor: labourFlag === 'IN_TRANSIT' ? 'grey.300' : 'grey.200',
                      borderRadius: '50%',
                      width: '48px',
                      height: '48px',
                      '&:hover': {
                        backgroundColor: 'grey.300',
                        color: 'primary.main',
                      },
                    }}
                  >
                    <SyncIcon fontSize="large" />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}

            {/* Search Filter Component */}
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder="Search By Customer Name"
            />
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={getFlag == 'CANCEL_BOOKING' ? TABLE_HEAD_CANCELBOOKING : TABLE_HEAD}
                  rowCount={bookingSpaces.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        parkingSlotRespDTO,
                        paymentStatus,
                        bookingCode,
                        transactionRefId,
                        bookingDate,
                        bookingAmount,
                        checkinTime,
                        checkoutTime,
                        customerDetailResponseDTO,
                        parkingSpaceLocationRespDTO,
                        serviceProviderDetailResponseDTO,
                        labourDetail,
                        bookingStatus,
                        cancellationReasonName,
                        bookingLabourMappingObj,
                        parkingCategoryResDTO,
                        subBookingDetailList,
                        taxAmount,
                        rewardUsed,
                        rewardGained,
                        convenienceFee,
                        actualCheckinTime,
                        actualCheckoutTime,
                        totalAmount,
                        countyTax,
                        salesTax,
                        stateTax,
                        fixedFee,
                        paymentMethodName,
                        fromLocation,
                        toLocation,
                        fromLatitude,
                        fromLongitude,
                        offerDetailId,
                        parkingCategoryId,
                        parkingTypeObj,
                        toLatitude,
                        toLongitude,
                        tollCharges,
                        paidBy,
                      } = row;
                      // const isItemSelected = selected.indexOf(itemName) !== -1;
                      return (
                        <>
                          <TableRow
                            hover
                            key={`${id + '-' + getUniqueKey() + 'allBookingId'}`}
                            tabIndex={-1}
                          // selected={isItemSelected}
                          // aria-checked={isItemSelected}
                          >
                            <TableCell align="left">
                              <Typography
                                fontWeight="semibold"
                                variant="subtitle2"
                                style={{
                                  color: 'blue',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  console.log("Sent Flag", getFlag);
                                  navigate('/dashboard/booking-details', {
                                    state: {
                                      id: id,
                                      labourFlag: labourFlag,
                                      getFlag: getFlag,
                                      parkingSlotRespDTO: parkingSlotRespDTO,
                                      paymentStatus: paymentStatus,
                                      bookingCode: bookingCode,
                                      transactionRefId: transactionRefId,
                                      actualCheckinTime: actualCheckinTime,
                                      actualCheckoutTime: actualCheckoutTime,
                                      bookingDate: bookingDate,
                                      bookingAmount: bookingAmount,
                                      checkinTime: checkinTime,
                                      checkoutTime: checkoutTime,
                                      customerDetailResponseDTO: customerDetailResponseDTO,
                                      parkingSpaceLocationRespDTO: parkingSpaceLocationRespDTO,
                                      serviceProviderDetailResponseDTO: serviceProviderDetailResponseDTO,
                                      bookingStatus: bookingStatus,
                                      taxAmount: taxAmount,
                                      rewardUsed: rewardUsed,
                                      rewardGained: rewardGained,
                                      convenienceFee: convenienceFee,
                                      totalAmount: totalAmount,
                                      cancellationReasonName: cancellationReasonName,
                                      countyTax: countyTax,
                                      salesTax: salesTax,
                                      stateTax: stateTax,
                                      fixedFee: fixedFee,
                                      tollCharges: tollCharges,
                                      labourDetail: labourDetail,
                                      fromLocation: fromLocation,
                                      toLocation: toLocation,
                                      paymentMethodName: paymentMethodName,
                                      bookingLabourMappingObj: bookingLabourMappingObj,
                                      fromLatitude: fromLatitude,
                                      fromLongitude: fromLongitude,
                                      offerDetailId: offerDetailId,
                                      parkingCategoryId: parkingCategoryId,
                                      parkingTypeObj: parkingTypeObj,
                                      toLatitude: toLatitude,
                                      toLongitude: toLongitude,
                                      paidBy: paidBy,
                                    },
                                  });
                                }}
                                align="left"
                              >
                                {bookingCode}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">{customerDetailResponseDTO?.name}</TableCell>
                            <TableCell align="left">
                              {parkingSpaceLocationRespDTO?.serviceProviderDetailResponseDTO?.vendorAlias}
                            </TableCell>
                            {/* <TableCell align="left">{parkingSpaceLocationRespDTO?.name}</TableCell> */}
                            <TableCell align="left">₹{totalAmount?.toFixed(2)}</TableCell>
                            {/* {getFlag !== 'CANCEL_BOOKING' ? (
                            <TableCell align="left">
                              {parkingCategoryResDTO?.subCategoryName !== null
                                ? parkingCategoryResDTO?.subCategoryName
                                : 'NA'}
                            </TableCell>
                          ) : null} */}
                            <TableCell align="left">{fDateTimeSuffix(bookingDate)}</TableCell>

                            {getFlag !== 'CANCEL_BOOKING' ? (
                              <TableCell align="left">
                                {fDateTimeSuffix(checkinTime)}
                              </TableCell>
                            ) : (
                              ''
                            )}
                            {getFlag !== 'CANCEL_BOOKING' ? (
                              <TableCell align="left">
                                {fDateTimeSuffix(checkoutTime)}
                              </TableCell>
                            ) : null}
                            {getFlag !== 'CANCEL_BOOKING' ? (
                              <Tooltip
                                title={fromLocation}
                                placement="bottom-end"
                                className="text-center"
                              >
                                <TableCell
                                  align="center"
                                  style={{
                                    maxWidth: '150px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {fromLocation}
                                </TableCell>
                              </Tooltip>
                            ) : null}
                            {getFlag !== 'CANCEL_BOOKING' ? (
                              <Tooltip
                                title={toLocation}
                                placement="bottom-end"
                                className="text-center"
                              >
                                <TableCell
                                  align="center"
                                  style={{
                                    maxWidth: '150px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {toLocation}
                                </TableCell>
                              </Tooltip>
                            ) : null}


                            <TableCell
                              align="left"
                              style={{
                                fontWeight: 'bold',
                                ...(timeInMiliseconds(actualCheckinTime, actualCheckoutTime, bookingStatus) >
                                  7200000 &&
                                  actualCheckinTime !== null &&
                                  actualCheckoutTime == null &&
                                  bookingStatus == 'booked'
                                  ? checkInStatusStyle
                                  : bookingStatus == 'Completed' || bookingStatus == 'Checkout'
                                    ? completedStatusStyle
                                    : bookingStatus == 'Checkout'
                                      ? checkoutStatusStyle
                                      : ''),
                              }}
                            >
                              {toUpper(
                                actualCheckinTime !== null && actualCheckoutTime == null && bookingStatus == 'booked'
                                  ? 'Checkin'
                                  : bookingStatus
                              )}
                            </TableCell>
                            {userType !== 'UTLB' && getFlag !== 'CANCEL_BOOKING' && (
                              (() => {
                                const status = bookingLabourMappingObj?.[0]?.status;

                                if (status === 'LABOUR_ACCEPTED') {
                                  return <TableCell>{bookingLabourMappingObj?.[0]?.labourDetail?.fullName}</TableCell>;
                                } else if (status === 'REQUEST_LABOUR') {
                                  return <TableCell>Driver Requested</TableCell>;
                                } else if (status === 'LABOUR_REJECTED') {
                                  return <TableCell>Driver Rejected</TableCell>;
                                } else {
                                  return <TableCell>N/A</TableCell>;
                                }
                              })()
                            )}
                            {userType === 'UTSP' && (labourFlag === null || labourFlag === 'LABOUR_REJECTED') && getFlag !== 'CANCEL_BOOKING' && (
                              <TableCell>
                                <Tooltip title="Add Driver">
                                  <IconButton
                                    onClick={() => handleAddDriver(id)}
                                    style={{ color: (['request_labour', 'labour_accepted', 'in_transit', 'Completed'].includes(bookingStatus) ? '#B0B0B0' : '#E23744') }}
                                    disabled={(bookingStatus === 'request_labour' || bookingStatus === 'labour_accepted' || bookingStatus === 'in_transit' || bookingStatus === 'Completed')}
                                  >
                                    <PersonAddIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            )}

                            {userType === 'UTLB' && getFlag !== 'CANCEL_BOOKING' && (
                              <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                  {labourFlag === 'LABOUR_ACCEPTED' && (
                                    <>
                                      <Tooltip title="Start Ride">
                                        <IconButton onClick={() => updateBookingStatusByLabour({
                                          token: token.token,
                                          bookingId: id,
                                          status: "IN_TRANSIT",
                                        })}
                                          style={{ color: 'green' }}>
                                          <PlayCircleOutlineIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  )}
                                  { /** labourFlag === 'IN_TRANSIT' && (
                                  <>
                                    <Tooltip title="Complete Ride">
                                      <IconButton onClick={() =>  updateBookingStatusByLabour({
                                            token: token.token,
                                            bookingId: id,
                                            status:"COMPLETED",
                                          }) } style={{ color: '#E23744' }}>
                                        <CheckCircleOutlineIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                ) */}
                                  {(labourFlag === 'REQUEST_LABOUR' &&   getFlag == 'CURRENT_BOOKING' ) && (
                                    <>
                                      <Tooltip title="Accept">
                                        <IconButton
                                          onClick={() =>
                                            lineUpLabourWithBooking({
                                              token: token.token,
                                              bookingId: id,
                                              labourId: bookingLabourMappingObj?.[0]?.labourDetail?.id,
                                              status: 'LABOUR_ACCEPTED'
                                            })
                                          }
                                          style={{ color: 'green' }}
                                        >
                                          <CheckIcon />
                                        </IconButton>
                                      </Tooltip>

                                      <Tooltip title="Reject">
                                        <IconButton
                                          onClick={() =>
                                            lineUpLabourWithBooking({
                                              token: token.token,
                                              bookingId: id,
                                              labourId: bookingLabourMappingObj?.[0]?.labourDetail?.id,
                                              status: 'LABOUR_REJECTED'
                                            })
                                          }
                                          style={{ color: '#E23744' }}
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                            {getFlag == 'CANCEL_BOOKING' ? (
                              <TableCell align="left">{cancellationReasonName}</TableCell>
                            ) : null}
                          </TableRow>
                        </>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={bookingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      {getAllBookingResponse.isLoading ? <Loading /> : null}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%' }}
      >
        <Box sx={styleActiveModel} style={{ overflowY: 'auto', height: '40%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Checkin History
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleClose();
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Box border={1} borderRadius={2} borderColor={'white'} style={{ backgroundColor: 'white' }}>
            <Box marginLeft={1} padding={3}>
              {subBooking.length == 0 && <p>Checkin history is not available</p>}
              <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                  {subBooking.length !== 0 && (
                    <Box sx={{ margin: 1 }}>
                      <Table size="small" aria-label="purchases">
                        <TableHead>
                          <TableRow>
                            <TableCell>Actual Checkin </TableCell>
                            <TableCell>Actual Checkout</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {subBooking.map((subBookin) => (
                            <TableRow key={subBookin.id}>
                              <TableCell>
                                {subBookin.actualCheckinTime ? fDateTimeSuffix(subBookin.actualCheckinTime) : '_'}
                              </TableCell>
                              <TableCell>
                                {subBookin.actualCheckoutTime ? fDateTimeSuffix(subBookin.actualCheckoutTime) : '_'}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openModal}
        onClose={handleOpenModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%' }}
      >
        <Box sx={styleActiveModel} style={{ overflowY: 'auto', height: '40%', width: '30%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Pos Machine
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleCloseModal();
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleStartPayment}
            validate={validate}
          >
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values, touched, errors }) => (
              <Box style={{ width: '100%' }}>


                <Box style={{ width: '100%' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Pos Device
                  </Typography>
                  <Select
                    id="posDevice"
                    name="posDevice"
                    style={{ width: '100%' }}
                    value={values.posDevice}
                    onChange={(event: any) => {
                      setFieldValue('posDevice', event.target.value);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.posDevice && errors.posDevice)}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                      Select Pos Device
                    </MenuItem>
                    {posDeviceData && posDeviceData.map((posDeviceData: any) => (
                      <MenuItem key={posDeviceData.deviceId} value={posDeviceData.deviceId}>
                        {posDeviceData.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.posDevice && <div style={{ color: 'red' }}>{errors.posDevice}</div>}
                </Box>
                <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    variant="contained"
                    size="large"
                    component="span"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            )}
          </Formik>


        </Box>
      </Modal>
      <Modal
        open={openAddDriverModal}
        onClose={handleCloseAddDriverModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%' }}
      >
        <Box
          sx={{
            ...styleActiveModel,
            overflowY: 'auto',
            height: { xs: 'auto', sm: '70%', md: '60%' },
            width: { xs: '90%', sm: '70%', md: '30%' },
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Line Up Driver
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={handleCloseAddDriverModal}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={{ addDriver: '' }}
            onSubmit={handleSubmitForm}
            validate={(values) => {
              const errors = {};
              if (!values.addDriver) errors.addDriver = 'Please select a driver';
              return errors;
            }}
          >
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values, touched, errors }) => (
              <Box style={{ width: '100%' }}>
                <Box style={{ width: '100%' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Request Driver for the Booking
                  </Typography>
                  <Select
                    id="addDriver"
                    name="addDriver"
                    style={{ width: '100%' }}
                    value={values.addDriver}
                    onChange={(event) => setFieldValue('addDriver', event.target.value)}
                    onBlur={handleBlur}
                    error={Boolean(touched.addDriver && errors.addDriver)}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                      Select Driver
                    </MenuItem>
                    {labourers.map((labour) => (
                      <MenuItem key={labour.id} value={labour.id}>
                        {labour.fullName}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.addDriver && <div style={{ color: 'red' }}>{errors.addDriver}</div>}
                </Box>
                <Box style={{ width: '100%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                  <Button
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                    variant="contained"
                    size="large"
                    component="span"
                    onClick={handleSubmit}
                  >
                    Request Driver
                  </Button>
                </Box>
              </Box>
            )}
          </Formik>
        </Box>
      </Modal>

    </Page>
  );
}
